import ApiAppRepository from "../repository/api-app-repository";

class ApiAppService
{
    #apiAppRepository;

    constructor() {
        this.#apiAppRepository = new ApiAppRepository();
    }

    async create(apiApp) {
        try {
            const data = await this.#apiAppRepository.create(apiApp);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async edit(apiApp) {
        try {
            const data = await this.#apiAppRepository.edit(apiApp);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async revoke(id) {
        try {
            const data = await this.#apiAppRepository.revoke(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async gridview(query) {
        try {
            const data = await this.#apiAppRepository.gridview(query);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async details(id) {
        try {
            const data = await this.#apiAppRepository.details(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async refreshToken(id) {
        try {
            const data = await this.#apiAppRepository.refreshToken(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default ApiAppService;